import moment from 'moment'

export const dateFormatter = (params) => {
    const date = moment(params.date).locale(params.locale);

    const formattedDate = params.locale === 'ru' ?
        date.format('dddd DD MMMM YYYY') : date.format('dddd Do MMMM YYYY');

    return {
        title: `${formattedDate} - ${params.time.start}`,
        id: params.time.id
    };
};



// WEBPACK FOOTER //
// ./src/dateFormatter/formatter.js